/**
 * Stage physics — integer fixed-step units for the Donkey Kong-style stage.
 *
 * The world is the original 224x256 Donkey Kong playfield. Positions are
 * integers in 1/16-pixel sub-units and time advances in 20ms ticks, so a
 * run replays identically everywhere (no float drift).
 */

export const SUB = 16; // sub-units per logical pixel
export const TICK_MS = 20; // 50Hz fixed step
export const WORLD_W_PX = 224;
export const WORLD_H_PX = 256;

export const WALK_SUB = 20; // 1.25 px/tick ≈ 62 px/s
export const CLIMB_SUB = 12; // 0.75 px/tick
export const JUMP_TICKS = 26; // 520ms, fixed arc like Donkey Kong
const JUMP_PEAK_PX = 14;
export const ALIGN_PX = 8; // ladder / work-spot reach (forgiving; climbing snaps to the ladder)

export const toSub = (px) => px * SUB;
export const toPx = (sub) => Math.floor(sub / SUB);
export const ticksAt = (ms) => Math.floor(ms / TICK_MS);

/** Height (sub-units) above the girder `i` ticks into a jump: an integer parabola. */
export function jumpHeightSub(i) {
  if (i <= 0 || i >= JUMP_TICKS) return 0;
  return Math.round((toSub(JUMP_PEAK_PX) * 4 * i * (JUMP_TICKS - i)) / (JUMP_TICKS * JUMP_TICKS));
}

export function aligned(aSub, bSub, tolPx = ALIGN_PX) {
  return Math.abs(aSub - bSub) <= toSub(tolPx);
}
